import { useParams } from 'react-router-dom';

/**
 * The tenant a screen is rendering (Phase 1 / T1.6A).
 *
 * Canonical URLs carry BOTH ids — `/app/b/:businessId/l/:locationId/…` — so a
 * screen reads them from one place instead of each component picking a param
 * name. Location screens previously read a single `:siteId`, which is exactly
 * the ambiguity the tenancy rename removed: the value after `/app/b/` is a
 * BUSINESS id now, and a Location id only ever appears after `/l/`.
 */
export function useTenantParams(): { businessId: string | undefined; locationId: string | undefined } {
  const { businessId, locationId } = useParams<{ businessId: string; locationId: string }>();
  return { businessId, locationId };
}

/** The Location a Location-scoped screen is rendering. */
export function useLocationId(): string | undefined {
  return useParams<{ locationId: string }>().locationId;
}

/** The Business a screen is rendering — present on every canonical tenant URL. */
export function useBusinessId(): string | undefined {
  return useParams<{ businessId: string }>().businessId;
}
